var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AdminCardListContainer',{attrs:{"is-page":false},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(slotData){return [_vm._t(name,null,null,slotData)]}}})],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }